import { render } from "./NoteAdmin.vue?vue&type=template&id=f5032cc4&scoped=true"
import script from "./NoteAdmin.vue?vue&type=script&lang=js"
export * from "./NoteAdmin.vue?vue&type=script&lang=js"

import "./NoteAdmin.vue?vue&type=style&index=0&id=f5032cc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5032cc4"]])

export default __exports__